module.exports = __webpack_public_path__ + "static/media/dxJyPie.3ef29671.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/dxJyPie.png
// module id = 1751
// module chunks = 0 1